// extracted by mini-css-extract-plugin
export default {"controls":"_3AIi2C5NkTe01LmO9fSVJ0","dots":"_3gWOwELwlrOcwDsPhvr5OA","arrows":"_3j4YFZm7LeYG2m9WLiPJUI"};